import ReactModal from 'react-modal';
import type { GroupId } from 'balus-common';
import { useTranslation, Trans } from 'react-i18next';
import { UserPagePathBuilder } from './pages/UserPagePathBuilder';

type Props = {
  groupId: GroupId;
};

const style: ReactModal.Styles = {
  overlay: {
    zIndex: 100,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    padding: '0',
    transform: 'translate(-50%, -50%)',
    minWidth: '500px',
  },
};

/**
 * 無期限のビューモデル閲覧権限を持たないユーザー向けのダイアログ
 * 作成後30日経過したビューモデルは閲覧できないことを通知する
 */
export const LimitedViewModelAccessDialog: React.FC<Props> = ({ groupId }: Props) => {
  const { t } = useTranslation();
  return (
    <ReactModal style={style} isOpen={true} ariaHideApp={false} shouldCloseOnOverlayClick={false}>
      <div className={'px-2'}>
        <div className={'m-3 text-xl'}>{t('sidebar.limitedAccess.title')}</div>
        <div className={'m-3'}>
          <Trans
            i18nKey="sidebar.limitedAccess.body"
            components={{
              helpLink: (
                <a
                  href="https://balus-help.levii.co.jp/hc/ja/requests/new"
                  className="text-blue-700 underline hover:no-underline"
                  target="_blank"
                  rel="noopener noreferrer"
                />
              ),
              licenseLink: (
                <a
                  href={UserPagePathBuilder.groupConsoleLicensePage(groupId)}
                  className="text-blue-700 underline hover:no-underline"
                />
              ),
            }}
          />
        </div>
      </div>
    </ReactModal>
  );
};
